import {
    Attribute,
    BelongsTo,
    HasMany,
    JsonApiDatastore,
    JsonApiModel,
    JsonApiModelConfig,
} from 'angular2-jsonapi'
import { Empresa } from './empresa.model'
import { Foto } from './foto.model'
import { TipoDeOperador } from './tipo-de-operador.enum'

@JsonApiModelConfig({
    type: 'operadores',
})
export class Operador extends JsonApiModel {
    @Attribute() nome: string
    @Attribute() login: number
    @Attribute() email: string
    @Attribute() tipo: TipoDeOperador
    @Attribute() acessaTodasAsEmpresas: boolean
    @Attribute() administra: boolean

    @BelongsTo() foto: Foto
    @HasMany() empresas: Empresa[]

    @Attribute() permissoes: string
    @Attribute() crm: string

    permissoesObj

    constructor(_datastore: JsonApiDatastore, data?: any) {
        super(_datastore, data)
        this.permissoesObj = this.permissoes ? JSON.parse(this.permissoes) : null
    }

    isSuperAdministrador() {
        return this.id === '1'
    }

    isAdministrador() {
        return this.administra
    }

    isColaborador() {
        return this.tipo === TipoDeOperador.Colaborador
    }

    isCliente() {
        return this.tipo === TipoDeOperador.Cliente
    }

    UsaCollect() {
        return this.permissoesObj.ConciliadorCartao
    }

    getPermissoesCollect() {
        return this.permissoesObj ? this.permissoesObj.ConciliadorCartao : null
    }

    hasPermissaoVisualizarCollect() {
        let permissoes = this.getPermissoesCollect()
        return permissoes ? permissoes.Visualizar : this.isSuperAdministrador()
    }
}



// WEBPACK FOOTER //
// ./src/app/pkw-data/core/operador.model.ts